import h from "../core/createElement";

export default function JsonRawContainer({ onChange, shared = {}, name = "jsoncon" }) {
    let invalid_timeout;

    const
        area = (<textarea onKeydown={(e) => indent_handler(e)} onChange={e => format_json_if_con(e)} spellcheck="false"></textarea>),
        container = (<article class="json-container"> {area} </article >);

    const
        format_json_if_con = () => {
            let v = to_json(area.value)
            if (v) area.value = JSON.stringify(v, undefined, 2);
            onChange && onChange(v);
        },
        to_json = (str) => {
            try {
                const treated_str = str.replace(/([\,\{])s*([\s\S]*?)\s*\:/gi, (match, symbol, key) => {
                    return `${symbol} ${key.trim().replaceAll('"', '').replace(/(\w+)/gi, (m, w) => `"${w}"`)}:`;
                });
                return JSON.parse(treated_str);
            } catch (e) {
                return null;
            };
        },
        indent_handler = (e) => {
            if (e.key == 'Tab') {
                e.preventDefault();
                const start = area.selectionStart, end = area.selectionEnd;

                area.value = `${area.value.substring(0, start)}  ${area.value.substring(end)}`;

                area.selectionStart = area.selectionEnd = start + 2;
            }
        };


    shared[name] = {
        invalid: (bool) => {
            clearTimeout(invalid_timeout);

            if (bool) invalid_timeout = setTimeout(() => {
                container.classList.remove('invalid');
            }, 3000);

            container.classList[bool ? 'add' : 'remove']('invalid')
        },
        setValue: (v) => {
            area.value = JSON.stringify(v, undefined, 2)
        }
    }

    return container;
}